import { ReactNode, createContext, useState } from "react";

type ViewStatus = "DEFAULT" | "EVENT" | "INVALID";
type LocalViewsContext = {
  localView: ViewStatus;
  setLocalView: (status: ViewStatus) => void;
  resetView: () => void;
};

export const LocalViewsContext = createContext<LocalViewsContext | null>(null);

export const LocalViewsProvider = ({ children }: { children: ReactNode }) => {
  const [localView, setLocalView] = useState<ViewStatus>("DEFAULT");

  return (
    <LocalViewsContext.Provider
      value={{
        localView,
        setLocalView,
        resetView: () => setLocalView("DEFAULT"),
      }}
    >
      {children}
    </LocalViewsContext.Provider>
  );
};
